import React from 'react';
import { connect } from 'react-redux';
import 'react-widgets/lib/less/react-widgets.less';
import { Row, Col, ControlLabel } from 'react-bootstrap';
import {
  Button,
} from '../../form/FormControls';
import FancyInput from '@/component/form/numinput/index';
import { save, loadInterest, goBack } from './interestrate.store';
import RequiredFormControl from '../../form/RequiredFormControl';
import { MainComponentBox, FormGroupWValidation as FormGroup,
  createFormData } from '../../../util/util';

class Edit extends React.Component {
  constructor() {
    super();
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentWillMount() {
    this.props.load();
  }

  onSubmit(event) {
    event.preventDefault();
    const formData = createFormData('interestRateForm');
    this.props.save(formData.rate);
  }

  render() {
    return (<div>
      <form id="interestRateForm" onSubmit={this.onSubmit}>
        <MainComponentBox>
          <Row>
            <Col xs={12} md={6} lg={4} className={'report-panel'}>
              <FormGroup id="rate">
                <ControlLabel style={{ height: 'auto' }}>Interest rate</ControlLabel>
                <RequiredFormControl
                  component={FancyInput}
                  className="form-control"
                  name="rate"
                  fraction={2}
                  positive
                  negative={false}
                  type="number"
                  value={this.props.rateValue}
                />
              </FormGroup>
              <Button
                id="saveButton"
                type="submit" bsStyle="primary" disabled={this.props.saving}
              >
                Save
              </Button>
              <Button id="cancelButton" onClick={this.props.cancel}>Cancel</Button>
            </Col>
          </Row>
        </MainComponentBox>
      </form>
    </div>);
  }
}

Edit.propTypes = {
  save: React.PropTypes.func,
  load: React.PropTypes.func,
  cancel: React.PropTypes.func,
  saving: React.PropTypes.bool,
  rateValue: React.PropTypes.number,
};

export default connect(state =>
  ({
    saving: state.getIn(['allaround', 'saving'], false),
    rateValue: state.getIn(['references', 'interestrate', 'value']),
  }), dispatch => ({
  save(value) {
    save(dispatch, value);
  },
  load() {
    loadInterest(dispatch);
  },
  cancel() {
    goBack(dispatch);
  },
}))(Edit);
